var _path, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassChangedBg = function SvgPassChangedBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 88,
    viewBox: "0 0 94 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6515 27.7762V34.5714H70.3214V27.7762C70.3214 14.1715 59.0646 3.14279 45.1786 3.14279C31.2925 3.14279 20.0357 14.1715 20.0357 27.7762V34.5714H28.7057V27.7762C28.7057 18.8628 36.0808 11.6371 45.1786 11.6371C54.2763 11.6371 61.6515 18.8628 61.6515 27.7762Z",
    fill: "#E9E8E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 34.5714,
    width: 62.8571,
    height: 45.5714,
    fill: "url(#pass_changed_bg_svg__paint0_linear_19162_7291)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3214,
    cy: 57.3571,
    r: 3.14286,
    fill: "#FFFDFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.75,
    cy: 57.3572,
    r: 3.14286,
    fill: "#FFFDFB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.1786,
    cy: 57.3572,
    r: 3.14286,
    fill: "#FFFDFB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.6072,
    cy: 57.3572,
    r: 3.14286,
    fill: "#FFFDFB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.0357,
    cy: 57.3572,
    r: 3.14286,
    fill: "#FFFDFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "pass_changed_bg_svg__mask0_19162_7291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 18,
    width: 33,
    height: 33
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.6071,
    cy: 34.5714,
    rx: 15.7143,
    ry: 15.7143,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pass_changed_bg_svg__mask0_19162_7291)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pass_changed_bg_svg__filter0_f_19162_7291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4973 20.1287C46.8855 21.9897 45.9655 25.3013 47.0678 28.893C49.2563 36.024 51.4556 43.1551 53.6202 50.2857C56.253 58.9035 58.7661 60.3503 65.4119 60.2127C80.6894 59.8526 96.2414 60.3239 111.719 60.5546C114.393 60.5869 115.782 58.0759 114.82 54.9481C109.905 38.9734 104.986 22.9875 100.083 7.00671C97.5706 -1.18231 86.5912 -6.30229 80.6364 -2.05925L49.4973 20.1287Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pass_changed_bg_svg__filter1_f_19162_7291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0585 55.4916C57.9557 55.8745 58.0763 56.3398 57.9713 56.7421C57.8663 57.1445 57.5467 58.1926 57.6568 58.456C57.8159 58.8366 57.7955 59.4824 58.336 59.7224C58.8584 59.9544 59.4979 59.7398 59.9857 59.6425C61.7763 59.2854 63.4207 58.4762 65.1114 57.907C65.9664 57.6191 66.9291 57.601 67.8183 57.3627C68.2516 57.2466 68.4087 56.9765 68.9214 56.9766C69.4138 56.9767 69.8438 56.82 70.2907 56.7002C71.3724 56.4104 72.4725 56.5657 73.6598 56.6123C74.9705 56.6636 76.5535 56.0427 77.659 55.591C81.1918 54.1474 82.9209 50.8488 85.4084 48.2638C86.3734 47.261 87.0616 46.0223 88.1519 45.1347C89.3004 44.1997 90.7359 43.7985 92.2164 43.4018C94.7413 42.7253 97.5593 42.0776 99.7207 40.7674C100.722 40.1603 101.551 39.4388 101.946 38.2601C102.371 36.9896 101.09 34.5948 99.8698 33.6058C99.1921 33.0566 97.796 32.8211 97.0294 32.6971C96.2163 32.5656 95.4221 32.5318 94.6308 32.515C91.6763 32.4524 88.9734 33.5192 86.7912 34.9878C84.0518 36.8314 80.7946 36.5868 77.4891 37.2187C75.9033 37.5219 74.4384 38.0698 72.9805 38.5978C72.0142 38.9478 71.5027 40.1763 70.8697 40.8935C69.0909 42.909 68.4401 45.704 66.1586 47.2255C65.0994 47.9319 63.9611 48.5927 62.6847 48.9611C61.9904 49.1614 60.9395 49.4305 60.4894 50.0019C59.6528 51.0641 58.5251 52.2075 58.3959 53.7314C58.3487 54.2871 58.1959 54.9802 58.0585 55.4916Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pass_changed_bg_svg__filter2_f_19162_7291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.1411 38.7621C68.4112 40.1173 67.6731 40.9193 66.6635 41.992C65.3639 43.3729 62.4141 44.0598 63.5752 45.6024C63.7751 45.8681 64.0249 46.1098 64.3057 46.2898C66.117 47.4509 66.5462 46.2305 67.8563 45.8246C70.1535 45.1131 71.5573 44.3739 74.218 44.1714C76.1731 44.0225 80.7876 45.9425 82.7179 46.9335C85.5935 48.4098 88.0103 44.8382 89.7676 43.6802C92.2998 42.0114 93.615 39.7614 97.0329 39.2198C100.42 38.6832 104.095 39.4961 107.629 39.8634C111.539 40.2698 114.448 40.5209 117.599 38.4441C120.274 36.6815 118.524 33.3773 117.896 30.9589C117.277 28.5771 113.224 26.5973 111.126 25.3862C108.412 23.8192 106.321 23.8187 103.441 23.6119C100.235 23.3817 97.5581 25.9778 94.4696 25.756C92.0164 25.5799 87.4567 23.9714 85.6127 25.6727C81.9741 29.0298 80.0545 32.8172 74.0503 33.2743C71.7607 33.4486 70.071 37.0353 69.1411 38.7621Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pass_changed_bg_svg__filter3_f_19162_7291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8994 25.4178C72.6293 24.0625 73.3673 23.2606 74.377 22.1878C75.6766 20.807 78.6264 20.1201 77.4653 18.5774C77.2654 18.3118 77.0156 18.0701 76.7348 17.8901C74.9234 16.729 74.4942 17.9494 73.1841 18.3552C70.887 19.0668 69.4832 19.8059 66.8225 20.0085C64.8674 20.1574 60.2529 18.2373 58.3226 17.2463C55.447 15.77 53.0302 19.3416 51.2729 20.4997C48.7407 22.1684 47.4255 24.4184 44.0075 24.96C40.6208 25.4967 36.9453 24.6838 33.4114 24.3165C29.5019 23.9101 26.5927 23.6589 23.4413 25.7358C20.7667 27.4984 22.5165 30.8025 23.1449 33.221C23.7637 35.6028 27.8164 37.5825 29.9142 38.7937C32.6283 40.3606 34.7199 40.3612 37.6 40.568C40.8058 40.7982 43.4824 38.2021 46.5708 38.4238C49.0241 38.6 53.5838 40.2085 55.4278 38.5071C59.0663 35.15 60.9859 31.3627 66.9901 30.9056C69.2798 30.7312 70.9695 27.1446 71.8994 25.4178Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pass_changed_bg_svg__filter4_f_19162_7291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4981 44.2621C81.7683 45.6173 81.0302 46.4193 80.0206 47.492C78.7209 48.8729 75.7712 49.5598 76.9323 51.1024C77.1322 51.3681 77.3819 51.6098 77.6627 51.7898C79.4741 52.9509 79.9033 51.7305 81.2134 51.3246C83.5105 50.6131 84.9144 49.8739 87.5751 49.6714C89.5302 49.5225 94.1447 51.4425 96.075 52.4335C98.9506 53.9098 101.367 50.3382 103.125 49.1802C105.657 47.5114 106.972 45.2614 110.39 44.7198C113.777 44.1832 117.452 44.9961 120.986 45.3634C124.896 45.7698 127.805 46.0209 130.956 43.9441C133.631 42.1815 131.881 38.8773 131.253 36.4589C130.634 34.0771 126.581 32.0973 124.483 30.8862C121.769 29.3192 119.678 29.3187 116.798 29.1119C113.592 28.8817 110.915 31.4778 107.827 31.256C105.373 31.0799 100.814 29.4714 98.9698 31.1727C95.3312 34.5298 93.4116 38.3172 87.4074 38.7743C85.1178 38.9486 83.428 42.5353 82.4981 44.2621Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2489 30.4154L74.3495 41.3149L67.7583 34.7238L69.9739 32.5082L74.3495 36.8837L83.0333 28.1998L85.2489 30.4154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pass_changed_bg_svg__filter0_f_19162_7291",
    x: 40.3245,
    y: -9.87022,
    width: 81.086,
    height: 76.7109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.14286,
    result: "effect1_foregroundBlur_19162_7291"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pass_changed_bg_svg__filter1_f_19162_7291",
    x: 54.4911,
    y: 29.3695,
    width: 50.6808,
    height: 33.5998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57143,
    result: "effect1_foregroundBlur_19162_7291"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pass_changed_bg_svg__filter2_f_19162_7291",
    x: 60.1671,
    y: 20.4546,
    width: 62.0158,
    height: 29.9739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57143,
    result: "effect1_foregroundBlur_19162_7291"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pass_changed_bg_svg__filter3_f_19162_7291",
    x: 18.8575,
    y: 13.7514,
    width: 62.0158,
    height: 29.9739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57143,
    result: "effect1_foregroundBlur_19162_7291"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pass_changed_bg_svg__filter4_f_19162_7291",
    x: 73.5242,
    y: 25.9546,
    width: 62.0158,
    height: 29.9739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57143,
    result: "effect1_foregroundBlur_19162_7291"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pass_changed_bg_svg__paint0_linear_19162_7291",
    x1: 45.1786,
    y1: 34.5714,
    x2: 45.1786,
    y2: 80.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E8E8"
  })))));
};
export default SvgPassChangedBg;